export const PARTICIPANTE_STATUS = {
  PENDENTE: 'pendente',
  SALVO: 'salvo',
};

export const PERFIL_LIDERANCA = {
  TODOS: 0,
  LIDERES: 1,
  NAO_LIDERES: 2,
};

export const PARTICIPANTES_FILTRO_CONFIRM_LIMIT = 1000;
export const PARTICIPANTES_FILTRO_MAX_LIMIT = 3000;
